import React, { useState } from "react";
import Modal from "./Modal";
import AllDates from "../components/AllDates";
import moment from "moment";

const formatDate = (date) => moment(date).format("ddd, MMM Do");
const formatMonthKey = (date) => moment(date).format("YYYY-MM");
const formatDisplayMonth = (date) => moment(date).format("MMMM YYYY");
const TODAY = moment().startOf("day");

const LiveVineyardStage = ({ info }) => {
  const artists = info || [];

  const getAllDatesByArtist = (name) => {
    const artist = artists.filter((x) => x.fields.name === name);
    if (artist.length) {
      return artist[0].fields;
    }
    return null;
  };

  const [selectedArtist, setSelectedArtist] = useState(null);
  const ArtistCard = ({ fields, date }) => {
    const website = fields.websites && fields.websites[0];
    const { name, location } = fields;

    return (
      <article className="vineyard-performance">
        <div className="vineyard-performance__date">{formatDate(date)}</div>
        <div className="vineyard-performance__details">
          <h3 className="vineyard-performance__name m-b-0">
            {website ? (
              <a href={website} target="_blank" rel="noopener noreferrer">
                {name}
              </a>
            ) : (
              name
            )}
          </h3>
          {location && (
            <p className="vineyard-performance__location m-b-0">
              from {location}
            </p>
          )}
        </div>
      </article>
    );
  };

  const groupArtistsByMonth = (list) => {
    const grouped = list.reduce((acc, artist) => {
      if (!artist.fields.date) {
        return acc;
      }
      const futureDates = artist.fields.date.filter((date) =>
        moment(date).isSameOrAfter(TODAY)
      );
      futureDates.forEach((date) => {
        const monthKey = formatMonthKey(date);
        if (!acc[monthKey]) {
          acc[monthKey] = {
            displayMonth: formatDisplayMonth(date),
            artists: [],
          };
        }
        acc[monthKey].artists.push({ ...artist, date });
        acc[monthKey].artists.sort((a, b) =>
          moment(a.date, "M/D/YY").diff(moment(b.date, "M/D/YY"))
        );
      });
      return acc;
    }, {});

    return grouped;
  };

  const renderArtists = (list) => {
    const groupedByMonth = groupArtistsByMonth(list);

    return Object.entries(groupedByMonth)
      .sort(([monthA], [monthB]) => moment(monthA).diff(moment(monthB)))
      .map(([month, { displayMonth, artists }]) => {
        return (
          <section className="vineyard-month" key={month}>
            <h2 className="vineyard-month__title">{displayMonth}</h2>
            {artists.map((artist) => (
              <ArtistCard
                key={`${artist.fields.name}-${artist.date}`}
                fields={artist.fields}
                date={artist.date}
              />
            ))}
          </section>
        );
      });
  };

  const groupedByMonth = groupArtistsByMonth(artists);
  const hasUpcomingShows = Object.keys(groupedByMonth).length > 0;

  return (
    <div className="container p-t-100 m-b-50 live-vineyard-stage">
      <header className="live-vineyard-stage__hero">
        <h1 className="huge-text-no-quote">LIVE!</h1>
        <h2>from the vineyard stage</h2>
        <p className="live-vineyard-stage__intro">
          Every Saturday night we welcome amazing performers from the region,
          Philly, and beyond. Browse upcoming performances below to plan your
          next visit.
        </p>
      </header>
      <Modal
        show={selectedArtist}
        component={AllDates}
        closeFn={() => setSelectedArtist(null)}
        content={getAllDatesByArtist(selectedArtist)}
      />
      <main className="live-vineyard-stage__schedule">
        {hasUpcomingShows ? (
          renderArtists(artists)
        ) : (
          <p className="live-vineyard-stage__empty">
            Upcoming performances will be posted soon. Check back shortly for
            new dates.
          </p>
        )}
      </main>
    </div>
  );
};

export default LiveVineyardStage;
